module.exports = __webpack_public_path__ + "img/pr_gspt1-e1500450055822.6e52ceb8.png";